import React, { useState } from "react";
import { Phone, Mail, Clock } from "lucide-react";
import { CONTACT } from "../mock";
import api from "../lib/api";

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    equipment: "Dry Van",
    message: "",
  });
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Persist the lead to the backend (best-effort)
    api.post("/contact", { ...form, kind: "contact" }).catch(() => {});
    const subject = encodeURIComponent(`Load / Dispatch Inquiry from ${form.name}`);
    const body = encodeURIComponent(
      `Name: ${form.name}\nPhone: ${form.phone}\nEmail: ${form.email}\nEquipment: ${form.equipment}\n\nMessage:\n${form.message}`
    );
    window.location.href = `mailto:${CONTACT.email}?subject=${subject}&body=${body}`;
    setSuccess(true);
  };

  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="section-head">
          <span className="kicker">Get In Touch</span>
          <h2>Ready to get your truck loaded?</h2>
          <p>Reach out directly, or send your info below and we'll get back to you about available loads and dispatch service.</p>
        </div>

        <div className="contact-grid">
          <div className="contact-info">
            <a className="info-card" href={`tel:${CONTACT.phoneRaw}`}>
              <span className="icon"><Phone strokeWidth={2} /></span>
              <span><span className="label">Call Dispatch</span><br /><span className="value">{CONTACT.phone}</span></span>
            </a>
            <a className="info-card" href={`mailto:${CONTACT.email}`}>
              <span className="icon"><Mail strokeWidth={2} /></span>
              <span><span className="label">Email</span><br /><span className="value" style={{ fontSize: "14px" }}>{CONTACT.email}</span></span>
            </a>
            <div className="info-card" style={{ cursor: "default" }}>
              <span className="icon"><Clock strokeWidth={2} /></span>
              <span><span className="label">Availability</span><br /><span className="value">{CONTACT.availability}</span></span>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className={`form-success ${success ? "show" : ""}`}>Your email app should now be open with your message ready to send.</div>
            <div className="form-row">
              <div className="field">
                <label htmlFor="name">Full Name</label>
                <input type="text" id="name" name="name" required placeholder="Jane Trucker" value={form.name} onChange={handleChange} />
              </div>
              <div className="field">
                <label htmlFor="phone">Phone</label>
                <input type="tel" id="phone" name="phone" required placeholder="(555) 555-5555" value={form.phone} onChange={handleChange} />
              </div>
            </div>
            <div className="form-row">
              <div className="field">
                <label htmlFor="email">Email</label>
                <input type="email" id="email" name="email" required placeholder="you@email.com" value={form.email} onChange={handleChange} />
              </div>
              <div className="field">
                <label htmlFor="equipment">Equipment Type</label>
                <select id="equipment" name="equipment" value={form.equipment} onChange={handleChange}>
                  <option>Dry Van</option>
                  <option>Reefer</option>
                  <option>Flatbed</option>
                  <option>Box Truck</option>
                  <option>Sprinter Van</option>
                  <option>Other</option>
                </select>
              </div>
            </div>
            <div className="form-row">
              <div className="field full">
                <label htmlFor="message">Message</label>
                <textarea id="message" name="message" placeholder="Tell us your current location, available date, and preferred lanes..." value={form.message} onChange={handleChange}></textarea>
              </div>
            </div>
            <button type="submit" className="btn btn-primary btn-block">Send Message</button>
            <p className="form-note">Submitting opens your email app addressed to {CONTACT.email} with your details filled in.</p>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
